"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const AuthenticationFactor_1 = require("../../enums/AuthenticationFactor");
const stepup_1 = tslib_1.__importDefault(require("../stepup"));
const Slide_vue_1 = tslib_1.__importDefault(require("../Slide.vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const SlideHeader_vue_1 = tslib_1.__importDefault(require("../SlideHeader.vue"));
exports.default = vue_1.default.extend({
    name: 'step-up',
    props: {},
    data: () => {
        return {
            selectedStepUpCategoryId: null,
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {
        stepUpCategories() {
            const categories = this.$store.state.currentChallenge.StepUpCategories || [];
            const displayCategories = categories
                .filter(category => category.StepUpModel.AuthenticationFactorValue !== 'Unknown');
            return displayCategories;
        },
        selectedStepUpCategory: {
            get() {
                const id = this.selectedStepUpCategoryId;
                return this.stepUpCategories.find((category) => category.$id === id) || this.stepUpCategories[0];
            },
            set(category) {
                this.selectedStepUpCategoryId = category.$id;
            },
        },
        authenticationFactorMetaData() {
            const getMetaData = (type) => {
                switch (type) {
                    case AuthenticationFactor_1.AuthenticationFactor.SmsCode:
                        return {
                            icon: 'mobile-sms',
                            label: this.getSiteText('Stepup.Icon.Label.SMS'),
                        };
                    case AuthenticationFactor_1.AuthenticationFactor.EmailCode:
                        return {
                            icon: 'email-alt',
                            label: this.getSiteText('Stepup.Icon.Label.EmailCode'),
                        };
                    case AuthenticationFactor_1.AuthenticationFactor.VoiceCode:
                        return {
                            icon: 'receive-call',
                            label: this.getSiteText('Stepup.Icon.Label.VoiceCode'),
                        };
                    case AuthenticationFactor_1.AuthenticationFactor.TOTP:
                        return {
                            icon: 'phone2',
                            label: this.getSiteText('Stepup.Icon.Label.TOTP'),
                        };
                    case AuthenticationFactor_1.AuthenticationFactor.Token:
                        return {
                            icon: 'lock',
                            label: this.getSiteText('Stepup.Icon.Label.Token'),
                        };
                    default:
                        return {
                            icon: 'cut-out',
                            label: this.getSiteText('Stepup.Icon.Label.Unknown'),
                        };
                }
            };
            const metadata = {};
            this.stepUpCategories.forEach((category) => {
                metadata[category.StepUpModel.AuthenticationFactorValue] = getMetaData(category.StepUpModel.AuthenticationFactorValue);
            });
            return metadata;
        },
        manualMfaEnabled() {
            const categories = this.$store.state.currentChallenge.StepUpCategories || [];
            const selectedCategory = categories
                .find(category => category.StepUpModel.AuthenticationFactorValue === 'Unknown');
            const manualDestination = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.StepUpModel.Destinations.find(x => x.MaskedAddress === 'Manual');
            if (manualDestination !== undefined) {
                return true;
            }
            return false;
        },
    },
    methods: {
        categoryChanged(selectedCategory) {
            this.selectedStepUpCategory = selectedCategory;
            this.$store.commit('setRememberDevice', false);
            this.$store.commit('setDeviceName', '');
        },
        async submitManualMfa() {
            if (this.manualMfaEnabled) {
                const categories = this.$store.state.currentChallenge.StepUpCategories || [];
                const selectedCategory = categories
                    .find(category => category.StepUpModel.AuthenticationFactorValue === 'Unknown');
                const challenge = {
                    ...selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.NextChallenge,
                    Destination: { ...selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.StepUpModel.Destinations.find(x => x.MaskedAddress === 'Manual') },
                };
                await this.$store
                    .dispatch('submitChallenge', {
                    ...challenge,
                    Destination: { ...selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.StepUpModel.Destinations.find(x => x.MaskedAddress === 'Manual') },
                });
            }
        },
    },
    mounted() {
        this.selectedStepUpCategory = this.stepUpCategories[0];
    },
    components: {
        IsotopeSlide: Slide_vue_1.default,
        ...stepup_1.default,
        SlideHeader: SlideHeader_vue_1.default,
    },
});
